import type { RewardBundle } from '@vm/shared';

/** 7-day login cycle. Missing a day restarts the cycle at day 1. */
export const DAILY_LOGIN_REWARDS: readonly RewardBundle[] = [
  { coins: 100 },
  { coins: 150 },
  { gems: 5 },
  { coins: 250 },
  { coins: 300 },
  { gems: 10 },
  { coins: 500, gems: 25 },
];

/** Reward for cycle day 1..n (wraps); `rewards` is the live cycle (defaults to the built-in one). */
export function dailyLoginReward(day: number, rewards: readonly RewardBundle[] = DAILY_LOGIN_REWARDS): RewardBundle {
  const n = rewards.length || DAILY_LOGIN_REWARDS.length;
  const list = rewards.length ? rewards : DAILY_LOGIN_REWARDS;
  const i = (((Math.floor(day) - 1) % n) + n) % n;
  return { ...list[i] };
}

/** UTC day key ('YYYY-MM-DD') shifted by `days`. */
export function shiftDayKey(dayKey: string, days: number): string {
  const [y, m, d] = dayKey.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}

export interface DailyLoginState {
  /** Cycle day claimed today, or the day that the next claim will grant. */
  day: number;
  claimedToday: boolean;
  /** Reward of the next claim (tomorrow's when already claimed today). */
  nextReward: RewardBundle;
}

/**
 * Login state from the last claim (`lastDay` UTC key + the cycle day claimed then) and today's key.
 * Consecutive days advance the cycle; a gap restarts at day 1.
 */
export function dailyLoginState(lastDay: string | null, lastCycleDay: number, today: string, rewards: readonly RewardBundle[] = DAILY_LOGIN_REWARDS): DailyLoginState {
  const len = rewards.length || DAILY_LOGIN_REWARDS.length;
  if (lastDay === today) {
    const next = (lastCycleDay % len) + 1;
    return { day: lastCycleDay, claimedToday: true, nextReward: dailyLoginReward(next, rewards) };
  }
  const day = lastDay && shiftDayKey(lastDay, 1) === today ? (lastCycleDay % len) + 1 : 1;
  return { day, claimedToday: false, nextReward: dailyLoginReward(day, rewards) };
}
